import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import { useBoxSize } from '../system';
var borderSizes = {
  xs: 2,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};

/**
 * Displays a user's avatar in a circle.
 */
function Avatar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      source = _ref.source,
      status = _ref.status,
      restProps = _objectWithoutPropertiesLoose(_ref, ["size", "source", "status"]);

  var _useBoxSize = useBoxSize(size),
      boxSize = _useBoxSize.boxSize;

  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "img",
    src: source,
    width: boxSize,
    height: boxSize,
    flexBasis: boxSize,
    flexShrink: 0,
    flexGrow: 0,
    objectFit: "cover",
    radius: "circle",
    borderColor: status,
    borderWidth: status ? borderSizes[size] : 0
  }, restProps));
}

export default Avatar;